import styled from "styled-components";
import { FlexContainer } from "styled/Box";

export const PageStikyHeading = styled(FlexContainer)<{ $stiky: boolean }>`
  ${({ $stiky }) =>
    $stiky &&
    `
position: sticky;
  top: 96px;
  background: rgb(245, 245, 245);
  z-index: 1;
  margin: 0 -5px;
  padding: 0 5px;

  @media (max-width: 1023px) {
    top: 80px;
  }
  `}
`;

export const PageStikyCategories = styled(FlexContainer)<{ $stiky: boolean }>`
  ${({ $stiky }) =>
    $stiky &&
    `
    position: sticky;
  top: 192px;
  background: rgb(245, 245, 245);
  z-index: 1;
  margin: 0px -5px 0px;
  padding: 0px 5px 0px;

  @media (max-width: 1023px) {
    top: 176px;
  }
  `}
`;

export const PageHeadingContainer = styled(FlexContainer)`
  margin-top: -32px;
  padding-top: 32px;
  z-index: 1;
  background: rgb(245, 245, 245);
  margin: -32px -5px -24px;
  padding: 32px 5px 24px;
`;
